import { session } from "./session";

function workspaceKey() {
  const email = session.getEmail()?.trim().toLowerCase();
  return email ? `active_workspace:v2:${encodeURIComponent(email)}` : null;
}

export function setWorkspace(ws) {
  const key = workspaceKey();
  if (!key) return;
  if (!ws) {
    localStorage.removeItem(key);
    return;
  }
  localStorage.setItem(key, JSON.stringify(ws));
}

export function getWorkspace() {
  try {
    const key = workspaceKey();
    if (!key) return null;
    // Never adopt the legacy shared selection: its owner cannot be proven.
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.id) return null;
    return parsed;
  } catch {
    const key = workspaceKey();
    if (key) localStorage.removeItem(key);
    return null;
  }
}

// Legacy export for backwards compatibility
export const workspaceStore = {
  getSelected: getWorkspace,
  setSelected: setWorkspace,
  clearSelected: () => setWorkspace(null),
};

export function getActiveWorkspace() {
  return getWorkspace();
}

export function getActiveWorkspaceId() {
  const ws = getActiveWorkspace();
  return ws?.id || ws?.workspace_id || null;
}

export function getWorkspaceSelectedAvatar() {
  const ws = getActiveWorkspace();
  if (!ws || !ws.selected_avatar_id) return null;

  return {
    id: ws.selected_avatar_id,
    name: ws.selected_avatar_name || "",
    image_url: ws.selected_avatar_image_url || "",
  };
}

export function setActiveWorkspaceAvatar(avatar) {
  const ws = getActiveWorkspace();
  if (!ws) return;

  const selectedAvatar = avatar?.id
    ? {
        id: avatar.id,
        name: avatar.name || "",
        image_url: avatar.image_url || "",
        avatar_image_url: avatar.image_url || "",
        source: "omnimark_generated",
      }
    : null;

  const updated = {
    ...ws,
    selected_avatar_id: selectedAvatar?.id || null,
    selected_avatar_name: selectedAvatar?.name || null,
    selected_avatar_image_url: selectedAvatar?.image_url || "",
  };

  setWorkspace(updated);

  if (selectedAvatar?.id) {
    localStorage.setItem("selected_avatar_id", selectedAvatar.id);
    localStorage.setItem("selected_avatar_name", selectedAvatar.name || "");
    localStorage.setItem("selected_avatar_image_url", selectedAvatar.image_url || "");
    localStorage.setItem("selected_avatar", JSON.stringify(selectedAvatar));
    localStorage.setItem("omnimark_selected_avatar", JSON.stringify(selectedAvatar));
    localStorage.setItem(`selected_avatar_${updated.id}`, JSON.stringify(selectedAvatar));
    localStorage.setItem(`omnimark_selected_avatar_${updated.id}`, JSON.stringify(selectedAvatar));
  } else {
    localStorage.removeItem("selected_avatar_id");
    localStorage.removeItem("selected_avatar_name");
    localStorage.removeItem("selected_avatar_image_url");
    localStorage.removeItem("selected_avatar");
    localStorage.removeItem("omnimark_selected_avatar");
    if (updated.id) {
      localStorage.removeItem(`selected_avatar_${updated.id}`);
      localStorage.removeItem(`omnimark_selected_avatar_${updated.id}`);
    }
  }

  window.dispatchEvent(new Event("workspace-avatar-changed"));
}
